import * as React from 'react';
import { useEffect, useState } from 'react';

import { TICKETING_SERVICE_BASEURL } from '../../config/browser';
import { SycamoreTicketingWidgetProps } from './SycamoreTicketingWidget.props';
import { StyledTicketingWidget } from './SycamoreTicketingWidget.styles';

const getCountryCode = (locale: string | undefined) => {
  switch (locale?.toLowerCase()) {
    case 'en-us':
      return 'us';
    case 'de-de':
      return 'de';
    case 'de-at':
      return 'de';
    case 'en-gb':
      return 'uk';
    default:
      return 'us';
  }
};

export const SycamoreTicketingWidget = ({ ...props }: SycamoreTicketingWidgetProps) => {
  const [hasLoadedScript, setHasLoadedScript] = useState(false);

  useEffect(() => {
    if (!hasLoadedScript) {
      let assetServerPath = 'https://d1t0cvd33zox42.cloudfront.net/';
      if (!(typeof window === 'undefined')) {
        if (window.location.href.indexOf('localhost') !== -1) {
          assetServerPath = 'http://wbportal/';
        }
      }
      const script = document.createElement('script');
      script.src = assetServerPath + 'embed/assets/js/jquery-3.6.0.min.js';
      script.async = true;
      let scriptSyca: HTMLScriptElement;
      script.onload = () => {
        scriptSyca = document.createElement('script');
        scriptSyca.src = assetServerPath + 'embed/assets/js/sycaconst.js';
        scriptSyca.async = true;
        scriptSyca.onload = () => {
          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.id = 'analyticsBaseURL';
          hiddenInput.name = 'analyticsBaseURL';
          hiddenInput.value = TICKETING_SERVICE_BASEURL;
          document.body.appendChild(hiddenInput);
          setHasLoadedScript(true);
        };
        document.body.appendChild(scriptSyca);
      };
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
        document.body.removeChild(scriptSyca);
      };
    }
  }, [hasLoadedScript]);

  return (
    <StyledTicketingWidget>
      <div
        id='syca_embedWBPortalContainer'
        data-countrycode={getCountryCode(props.movie.locale)}
        data-sycamovieid={props.movie.sycamoreId}
      />
    </StyledTicketingWidget>
  );
};
